/* ==========================================================================
   Elevate Floors — Seção 06: Layer by layer

   Um número de 0 a 1 comanda tudo. No desktop ele vem do quanto já se rolou
   DENTRO do trilho; no mobile, da posição da pilha na tela (lá não há pin).

   O JS escreve custom properties, nunca style.transform: a transição de .18s
   está no CSS, então o navegador interpola sozinho, o prefers-reduced-motion
   continua valendo pela folha de estilo, e o JS nunca disputa com ela.
   ========================================================================== */
(function () {
  'use strict';

  function initSection(section) {
    if (section._efBuildupBound) return;
    section._efBuildupBound = true;

    var pin = section.querySelector('.ef-buildup__pin');
    var stack = section.querySelector('[data-stack]');
    var layers = Array.prototype.slice.call(section.querySelectorAll('[data-layer]'));
    var card = section.querySelector('[data-card]');
    if (!pin || !stack || !layers.length) return;

    var cs = getComputedStyle(section);
    var SPREAD = parseFloat(cs.getPropertyValue('--ef-bu-spread')) || 46;
    var REST = parseFloat(cs.getPropertyValue('--ef-bu-rest')) || 8;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var mobileQ = window.matchMedia('(max-width: 900px)');

    var lastP = -1;
    var ticking = false;

    function paint(p) {
      // (i - mid) dá -1.5, -0.5, +0.5, +1.5 para quatro camadas: elas se
      // afastam do CENTRO da pilha, simetricamente, em vez de descerem juntas
      var mid = (layers.length - 1) / 2;
      layers.forEach(function (img, i) {
        var y = (i - mid) * (REST + SPREAD * p);
        img.style.setProperty('--y', y.toFixed(1) + 'px');
      });
      if (card) {
        // o cartão termina de aparecer no primeiro terço do curso
        var o = Math.min(1, p * 2.2);
        card.style.setProperty('--card-o', o.toFixed(2));
        card.style.setProperty('--card-y', (14 - 14 * o).toFixed(1) + 'px');
      }
    }

    function measure() {
      ticking = false;
      if (reduce.matches) {
        if (lastP !== 1) { lastP = 1; paint(1); }
        return;
      }

      var vh = window.innerHeight || 1;
      var next;

      if (mobileQ.matches) {
        // sem pin: o progresso vem da posição da pilha. Curso curto, porque
        // nada está preso na tela.
        var rs = stack.getBoundingClientRect();
        next = (vh * 0.68 - rs.top) / (vh * 0.42);
      } else {
        var tr = section.getBoundingClientRect();
        var sc = getComputedStyle(section);
        var padT = parseFloat(sc.paddingTop) || 0;
        var padB = parseFloat(sc.paddingBottom) || 0;
        // o curso real é a altura da seção MENOS o que fica preso; usar
        // tr.height direto faria a animação terminar cedo demais
        var content = tr.height - padT - padB;
        var span = Math.max(1, content - pin.offsetHeight);
        // descontar o top do sticky, ou o progresso começa negativo e a
        // animação dá um solavanco na entrada
        var pinTop = parseFloat(getComputedStyle(pin).top) || 0;
        var started = -(tr.top + padT - pinTop);
        // completa em 90% do curso: os 10% finais são uma pausa com tudo
        // aberto, antes de a seção sair. Sem isso a peça é arrancada da tela
        // no exato instante em que fica pronta.
        next = (started / span) / 0.9;
      }

      next = Math.max(0, Math.min(1, next));
      // não escrever no DOM se nada mudou: corta a maioria dos frames em
      // rolagem lenta, e é o que separa uma seção fluida de uma que esquenta
      // o celular
      if (Math.abs(next - lastP) < 0.006) return;
      lastP = next;
      paint(next);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(measure);
    }

    // will-change só enquanto a seção está por perto
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        section.classList.toggle('is-live', entries[0].isIntersecting);
      }, { rootMargin: '200px 0px' }).observe(section);
    } else {
      section.classList.add('is-live');
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { lastP = -1; onScroll(); });
    if (mobileQ.addEventListener) {
      mobileQ.addEventListener('change', function () { lastP = -1; onScroll(); });
    }
    if (reduce.addEventListener) {
      reduce.addEventListener('change', function () { lastP = -1; onScroll(); });
    }

    measure();
  }

  function init() {
    document.querySelectorAll('[data-buildup]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
